import React from "react";
import { Mutation } from "react-apollo";
import gql from "graphql-tag";

const RefreshStripePlanMutation = props => (
  <Mutation
    mutation={gql`
      mutation RefreshStripePlan {
        refreshStripePlan {
          stripeInvoice {
            id
            amountDue
            amountPaid
            currency
            created
            status
            paymentIntentStatus
            paymentIntentClientSecret
          }
        }
      }
    `}
    {...props}
  />
);

export default RefreshStripePlanMutation;

export const withRefreshStripePlan = Component => props => (
  <RefreshStripePlanMutation>
    {refreshStripePlan => (
      <Component {...props} refreshStripePlan={refreshStripePlan} />
    )}
  </RefreshStripePlanMutation>
);
